import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ThemeService } from '../services/theme';
import { themeAsset } from '../services/theme-asset';

@Component({
  selector: 'app-v3-conditions-footer',
  templateUrl: './v3-conditions-footer.html',
  styleUrl: './v3-conditions-footer.scss',
  standalone: true,
  imports: [RouterLink],
})
export class V3ConditionsFooter {
  protected readonly themeService = inject(ThemeService);

  readonly logoSrc = themeAsset(this.themeService, 'finanzen');
}
